export const GET_GROUPS = "GET_GROUPS";
export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const GET_GROUPS_FAIL = "GET_GROUPS_FAIL";
export const ADD_GROUP = "ADD_GROUP";
export const EDIT_GROUP = "EDIT_GROUP";
export const DELETE_GROUP = "DELETE_GROUP";

export default function groups(
  state = {
    data: [],
    isLoading: true,
    hasError: false,
  },
  action,
) {
  switch (action.type) {
    case GET_GROUPS: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }

    case GET_GROUPS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        hasError: true,
      });
    }

    case GET_GROUPS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
      });
    }

    default:
      return state;
  }
}

export function getGroups() {
  return {
    type: GET_GROUPS,
    payload: {
      request: {
        url: "Group/",
      },
    },
  };
}

export function getGroupsUser(groupList = []) {
  return {
    type: GET_GROUPS,
    payload: {
      request: {
        url: "Group/GetGroupsByUser",
        method: "POST",
        data: groupList,
      },
    },
  };
}

export function getGroupsByIdList(groupsId = []) {
  return {
    type: GET_GROUPS,
    payload: {
      request: {
        url: "Group/GetGroupsByGroupsId",
        method: "POST",
        data: groupsId,
      },
    },
  };
}

export function addGroup(group) {
  return {
    type: ADD_GROUP,
    payload: {
      request: {
        url: "Group/",
        method: "POST",
        data: group,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getGroups());
        },
      },
    },
  };
}

export function editGroup(group) {
  return {
    type: EDIT_GROUP,
    payload: {
      request: {
        url: "Group/" + group.id,
        method: "PUT",
        data: group,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getGroups());
        },
      },
    },
  };
}

export function deleteGroup(id) {
  return {
    type: DELETE_GROUP,
    payload: {
      request: {
        url: "Group/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getGroups());
        },
      },
    },
  };
}
